// components/common/RouteArrow.jsx
// ─────────────────────────────────────────────────────────
// SVG arrow ระหว่างต้นทาง → ปลายทาง
// ใช้ใน: myjob, jobdetail, joboverview, job-complete-multi, job-incomplete
// ─────────────────────────────────────────────────────────

import React from 'react';

const RouteArrow = ({ style }) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        style={{ flexShrink: 0, marginTop: 18, ...style }}
    >
        <path
            d="M5 12h14M13 6l6 6-6 6"
            stroke="#94A3B8"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default RouteArrow;